<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.78604 0.707453C3.90655 0.594734 4.096 0.592266 4.21915 0.702104C4.46614 0.922389 4.86964 1.25898 5.14974 1.375C5.41443 1.48464 5.8559 1.51617 6.15589 1.52422C6.32884 1.52886 6.47112 1.67134 6.47506 1.84431C6.48222 2.15794 6.51277 2.62777 6.625 2.89871C6.73775 3.17091 7.0546 3.53616 7.27434 3.76986C7.39367 3.89678 7.39039 4.09985 7.2677 4.22353C7.04759 4.4454 6.73483 4.78978 6.625 5.05492C6.51324 5.32473 6.48285 5.8234 6.47558 6.15214C6.47172 6.3265 6.3264 6.46877 6.15201 6.47119C5.83883 6.47552 5.36937 6.50409 5.07747 6.625C4.77822 6.74895 4.42245 7.07067 4.20395 7.2875C4.08777 7.40278 3.9007 7.41442 3.77565 7.30883C3.48886 7.06667 3.01501 6.67467 2.89509 6.625C2.62917 6.51485 2.15975 6.48377 1.84556 6.47593C1.67214 6.4716 1.52996 6.32808 1.52721 6.15463C1.52209 5.83149 1.49334 5.34062 1.375 5.05492C1.26146 4.7808 0.964429 4.45171 0.747857 4.23482C0.619882 4.10666 0.619904 3.89328 0.74965 3.76691C0.992779 3.53011 1.34115 3.16174 1.4501 2.89871C1.55657 2.64168 1.56043 2.18101 1.54764 1.86455C1.54034 1.68403 1.68469 1.52801 1.86528 1.52275C2.18069 1.51357 2.63874 1.48118 2.89509 1.375C3.16555 1.26297 3.54929 0.92888 3.78604 0.707453Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M5.01877 3.30005L3.63087 4.81413L3 4.12591"
      stroke="white"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
